import { observable } from "mobx";
import Model from "@app/state/model/base";

export default class Bookmark extends Model {
    @observable _id = undefined;
    @observable document = undefined;
    @observable excel = undefined;
    @observable areas = [];
    @observable name = undefined;
    @observable categories = [];
}
